import { render } from "./App.vue?vue&type=template&id=48443b6a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=48443b6a&lang=less&scoped=true"

import exportComponent from "E:\\develop\\EBIEarthWebApp\\n-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48443b6a"]])

export default __exports__